import React from 'react';

import { StickyColumn } from 'features/sticky-column/sticky-column';
import { GridGap } from 'ui/grid/grid.types';
import { ResponsiveGrid } from 'ui/responsive-grid/responsive-grid';
import { SortingButton } from 'ui/sorting-button';
import { SortDirection } from 'ui/sorting-button/sorting-button.types';
import { Text } from 'ui/v2/typography/text';

import css from '../../user-statistic-events.module.scss';

interface Props {
  gridTemplateColumns: string;
  gridTemplateColumnsTablet: string;
  gridTemplateColumnsMobile: string;
  sort: SortDirection;
  setSort: (direction: SortDirection) => void;
}

const EventsListTableHeader = ({
  gridTemplateColumns,
  gridTemplateColumnsTablet,
  gridTemplateColumnsMobile,
  setSort,
  sort,
}: Props) => {
  return (
    <ResponsiveGrid
      alignItems="center"
      gap={GridGap.x2}
      gridTemplateColumns={gridTemplateColumns}
      mobile={{ gridTemplateColumns: gridTemplateColumnsMobile }}
      tablet={{ gridTemplateColumns: gridTemplateColumnsTablet }}
      gridAutoRows="40px"
      className={css.Table}
    >
      <SortingButton
        defaultDirection={sort}
        active={sort !== SortDirection.NONE}
        onChange={setSort}
        className={css.Sort}
      >
        Date
      </SortingButton>
      <Text type="headline" textAlign="center">
        Event Id
      </Text>
      <Text type="headline">Event name</Text>
      <Text type="headline">Token name</Text>
      <Text type="headline" textAlign="center">
        Status Deal
      </Text>
      <Text type="headline" textAlign="center">
        Executed
      </Text>
      <Text type="headline" textAlign="center">
        Token amount
      </Text>
      <Text type="headline" textAlign="center">
        Current Price
      </Text>
      <Text type="headline" textAlign="center">
        Current balance
      </Text>
      <Text type="headline" textAlign="center" className={css.Wrap}>
        Токен PnL
      </Text>
      <Text type="headline" textAlign="center" className={css.Wrap}>
        Expiration Yes/No
      </Text>
      <Text type="headline" textAlign="center" className={css.Wrap}>
        Expiration Win/Lose
      </Text>
      <StickyColumn>
        <Text type="headline" textAlign="center">
          All PnL
        </Text>
      </StickyColumn>
    </ResponsiveGrid>
  );
};

export default EventsListTableHeader;
